module.exports = __webpack_public_path__ + "img/gc_country_flag_hu.09bb09b4.svg";